// Inspired by https://github.com/mblarsen/vue-browser-acl/blob/master/index.js

import Vue from "vue";

/**
 *
 * @param {String | Boolean} permission - The name of the permission to check for (i.e. "edit_customer")
 * @returns {Boolean} - If the signed in user has the checked permission
 */
function can( permission ) {
	if ( typeof permission === "boolean" ) {
		return Vue.auth.check() === permission;
	}

	return Vue.auth.check( permission );
}

function canSome( arr ) {
	return arr.some( val => can( val[0], val[1] ) );
}

function canEvery( arr ) {
	return arr.every( val => can( val[0], val[1] ) );
}

export default {
	install( vue ) {
		vue.prototype.$can = can;
		vue.prototype.$can.some = canSome;
		vue.prototype.$can.every = canEvery;
	}
};
